import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useHead } from 'hoofd';
import { type i18n } from 'i18next';
import * as React from 'react';
import { CookiesProvider } from 'react-cookie';
import { I18nextProvider } from 'react-i18next';
import { useRoutes } from 'react-router-dom';

import { routes } from '@/config/router';
import { IS_PREPROD_OR_PROD } from '@/constants';
import NotFoundPageContainer from '@/containers/NotFoundPageContainer';
import { queryClient } from '@/graphql/client';

const RootContainer: React.FC<{ i18n: i18n }> = ({ i18n }) => {
  const router = useRoutes(routes);
  useHead({
    language: i18n.language,
    title: 'ETS Global - Scoring App',
  });
  return (
    <CookiesProvider defaultSetOptions={{ path: '/' }}>
      <QueryClientProvider client={queryClient}>
        {!IS_PREPROD_OR_PROD && <ReactQueryDevtools initialIsOpen={false} />}
        <I18nextProvider i18n={i18n}>{router ?? <NotFoundPageContainer />}</I18nextProvider>
      </QueryClientProvider>
    </CookiesProvider>
  );
};

export default RootContainer;
